import { render, staticRenderFns } from "./DashboardAssessmentWidget.vue?vue&type=template&id=49205873&scoped=true&lang=pug&"
import script from "./DashboardAssessmentWidget.vue?vue&type=script&lang=js&"
export * from "./DashboardAssessmentWidget.vue?vue&type=script&lang=js&"
import style0 from "./DashboardAssessmentWidget.vue?vue&type=style&index=0&id=49205873&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49205873",
  null
  
)

export default component.exports